import { REGIONAL_CLIMATE_DATA } from "@/data/regional-climate"

const REGION_ORDER = [
  "Gulf Coast",
  "Southeast",
  "Southwest",
  "Mid-Atlantic",
  "Central",
  "Pacific Northwest",
  "Northeast",
  "Mountain West",
  "Great Lakes",
  "Upper Midwest",
] as const

export function RegionalSoilTempTable() {
  const regions = REGION_ORDER.flatMap((name) => {
    const data = REGIONAL_CLIMATE_DATA[name]
    return data ? [{ name, data }] : []
  })

  return (
    <div>
      <p className="mb-3 text-xs sm:text-sm text-gray-500">
        Typical 2-inch soil temperature averages by US region, ordered south-to-north
        (earliest to latest spring warm-up). Use these as a planning baseline; pull current
        data above for your exact ZIP.
      </p>
      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <div className="hidden overflow-x-auto md:block">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50">
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Region
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Mar
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Apr
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  May
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Jun
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Jul
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Sep
                </th>
                <th className="px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500">
                  Oct
                </th>
              </tr>
            </thead>
            <tbody>
              {regions.map(({ name, data }, idx) => (
                <tr key={name} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                  <td className="px-3 py-3 align-top">
                    <p className="font-semibold text-gray-900">{name}</p>
                    <p className="text-xs text-gray-500">{data.zone}</p>
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.spring?.march ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.spring?.april ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.spring?.may ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.summer?.june ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.summer?.july ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.fall?.september ?? "—"}
                  </td>
                  <td className="px-3 py-3 align-top text-gray-700">
                    {data.soilTemperature?.fall?.october ?? "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="divide-y divide-gray-100 md:hidden">
          {regions.map(({ name, data }) => (
            <div key={name} className="p-4">
              <p className="text-base font-semibold text-gray-900">{name}</p>
              <p className="text-xs text-gray-500">{data.zone}</p>
              <dl className="mt-3 grid grid-cols-2 gap-2 text-sm">
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    March
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.spring?.march ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    April
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.spring?.april ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    May
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.spring?.may ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    June
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.summer?.june ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    July
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.summer?.july ?? "—"}
                  </dd>
                </div>
                <div>
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    September
                  </dt>
                  <dd className="text-gray-900">
                    {data.soilTemperature?.fall?.september ?? "—"}
                  </dd>
                </div>
              </dl>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
